import React from 'react';

import { Gadget, GadgetHeader } from '../gadgets.styled';
import TestExecutionGadgetView from './TestExecutionGadget.view';
import TestExecutionGadgetConfigView from './TestExecutionGadgetConfig.view';

interface TestExecutionGadgetProps {
  isQAlityConfigured: boolean;
}

const TestExecutionGadget: React.FC<TestExecutionGadgetProps> = ({
  isQAlityConfigured,
}: TestExecutionGadgetProps) => {
  return (
    <>
      <GadgetHeader>
        <h4>Recently executed Test Cases</h4>
      </GadgetHeader>
      <Gadget>
        {isQAlityConfigured ? (
          <TestExecutionGadgetView />
        ) : (
          <TestExecutionGadgetConfigView />
        )}
      </Gadget>
    </>
  );
};

export default TestExecutionGadget;
